module.exports = __webpack_public_path__ + "static/media/brush_8.web.3f0b9759.png";